/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';

import './styles.scss';
import WomanWithNotebook from 'assets/images/woman-with-notebook.png';
import { ToroLearnIcon } from '../icon';
import { checkIsSmall } from 'utils/breakpoints';
import { useScreenWidth } from 'utils/screenWidth';

interface IProps {
  redirectTo?: string;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  registeredUser: boolean;
  onSubmit?: ({ userProfile, formData }: any) => void;
}

const ModalToroForm = ({ showModal, setShowModal, registeredUser }: IProps): JSX.Element => {
    const modalRef = useRef<HTMLDivElement>(null);
    const isMobile: boolean = checkIsSmall(useScreenWidth());

    useEffect(() => {
        const handleClickOutside = (event: Event) => (modalRef.current && modalRef.current === event.target ? setShowModal(false) : null);

        document.addEventListener('click', handleClickOutside);

        return () => document.addEventListener('click', handleClickOutside);
    }, [modalRef, setShowModal]);

    return (
        <div ref={modalRef} className={`modal fade ${showModal ? 'show d-block' : ''} modal`} tabIndex={-1} role="dialog">
            <div className={'modal-dialog modal-dialog-centered modal_dialog'} role="document">
                <div className={'modal-content p-0 modal-content-body position-relative'}>
                    <div className="modal-body p-0">
                        <div className="row m-0">
                            <div className="col-12 col-md-6 my-5 py-3 px-5">
                                <div className="d-flex justify-content-between mb-4">
                                    <div>
                                        <h2 className="mb-4 font-size-4 text-dark font-weight-bold">
                                          Veja como acessar todos os cursos de graça.
                                        </h2>
                                        <p className="mb-3 font-size-7 text-dark">
                                        Se você tiver uma conta na Toro e transferir recursos poderá acessar todos os conteúdos de graça. É só seguir os passos abaixo.
                                        </p>
                                    </div>
                                </div>
                                <div className='mb-3'>
                                    <div className="modal_steps">
                                        <div className="modal_step d-flex align-items-center justify-content-between pb-3 mb-3">
                                            <p className={`font-size-7 mb-0 ${registeredUser ? 'text-success' : 'text-primary-dark'}`}>1º Finalize seu cadastro na Toro</p>
                                            {registeredUser && <ToroLearnIcon icon="check" size={15} fill="#00C898"/>}
                                        </div>
                                        <div className="modal_step pb-3 mb-3">
                                            <p className="font-size-7 mb-0 text-primary-dark">2º Transfira a partir de R$100 para a sua conta Toro.</p>
                                        </div>
                                        <div className="modal_step mb-3">
                                            <p className="font-size-7 mb-0 text-primary-dark">3º Pronto! Todo o conteúdo será liberado sem custo adicional.</p>
                                        </div>
                                    </div>

                                    <button type="submit" className="btn btn-primary btn-sm w-100 mt-4 mb-3 py-1" onClick={() => {
                                        window.location.href = registeredUser ? `${process.env.REACT_APP_APP_URL}/home/transferencia` : `${process.env.REACT_APP_SIGNUP_SITE_URL}/campanha/aprenda-cursos`;
                                    }}>
                                        <p className="py-2 m-0 font-size-9 text-white">{registeredUser ? 'Transferir recursos' : 'Finalizar sua conta na Toro'}</p>
                                    </button>
                                </div>

                            </div>
                            {!isMobile && (
                                <div className="col-6 p-0 position-relative">
                                    <div className='modal-content-image'>
                                        <img
                                            className="h-100 w-100"
                                            src={`${WomanWithNotebook}`}
                                            alt="Mulher usando notebook"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div>
                        <button type="button" className='btn modal-button-close p-0' onClick={() => setShowModal(false)}>
                            <ToroLearnIcon icon="cross" fill="white" size={15} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalToroForm;
